import { StatusCodes } from "http-status-codes"
import { useContext, useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { useHashTab } from "../../../../../../hooks/useHashTab"
import { digitalManagerApi } from "../../../../../../services/api"
import type { DiMaDetailsHeaderProps } from "../../../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../../../components/DiMaProgress"
import { DetailsHeaderTab } from "../../../../../components/Helpers"
import { UserContext } from "../../../../../context/UserContext"
import { ApplicationPermissionFirmwareConstraintGet } from "../../../../../models/ApplicationPermissionFirmwareConstraint"
import { ApplicationPermissionFirmwareConstraintDetails } from "./details_tab/ApplicationPermissionFirmwareConstraintDetails"
import { ApplicationPermissionFirmwareConstraintRoles } from "./roles_tab/ApplicationPermissionFirmwareConstraintRoles"

export function ApplicationPermissionFirmwareConstraintContainer() {
  const { user, isLoadingUser } = useContext(UserContext)
  const { applicationId, permissionId, firmwareConstraintId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [firmwareConstraint, setFirmwareConstraint] =
    useState<ApplicationPermissionFirmwareConstraintGet>()

  const returnURL = `/applications/${applicationId}/permissions/${permissionId}#fw-constraints`

  useEffect(() => {
    if (applicationId && permissionId && firmwareConstraintId) {
      digitalManagerApi
        .get<ApplicationPermissionFirmwareConstraintGet>(
          `/applications/${applicationId}/permissions/${permissionId}/firmwareConstraints/${firmwareConstraintId}`
        )
        .then((res) => {
          if (res.status === StatusCodes.OK) {
            setFirmwareConstraint(res.data)
          }
        })
        .catch((err) => {
          if (err.response?.status) {
            navigate(returnURL)
          }
        })
    }
  }, [applicationId, permissionId, firmwareConstraintId, navigate, returnURL])

  if (!applicationId || !permissionId || !firmwareConstraintId) {
    return <Navigate to="/applications" />
  }

  if (!firmwareConstraint || isLoadingUser || !user) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: `${firmwareConstraint.device?.slaveId} - ${firmwareConstraint.device?.name}`,
    label: "Firmware Constraint ID",
    subtitle: firmwareConstraint.id,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DetailsHeaderTab
        detailsHeaderProps={detailsHeaderProps}
        tabItems={[
          { id: "details", label: "Details" },
          { id: "roles", label: "Roles exclusion" },
        ]}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      {activeTab === "details" && (
        <ApplicationPermissionFirmwareConstraintDetails
          firmwareConstraint={firmwareConstraint}
          applicationId={applicationId}
          permissionId={permissionId}
          user={user}
          setFirmwareConstraint={setFirmwareConstraint}
        />
      )}

      {activeTab === "roles" && <ApplicationPermissionFirmwareConstraintRoles />}
    </div>
  )
}
